import React, { useState } from 'react';
import styles from '../../styles/Building MGMT/UnitTours.module.css';

const UnitTours = ({ unitId }) => {
  const [tourRequests, setTourRequests] = useState([
    { id: 1, tenantName: "John Doe", requestedAt: "Mar 1, 10:00 AM", status: "Requested" },
    { id: 2, tenantName: "Jane Smith", requestedAt: "Mar 2, 2:00 PM", status: "Confirmed" },
    { id: 3, tenantName: "Mike Brown", requestedAt: "Mar 3, 3:00 PM", status: "Pending Approval" },
  ]);

  const handleApprove = (id) => {
    setTourRequests(prev =>
      prev.map(req => req.id === id ? {...req, status: "Confirmed"} : req)
    );
  };

  const handleDecline = (id) => {
    setTourRequests(prev =>
      prev.map(req => req.id === id ? {...req, status: "Declined"} : req)
    );
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.header}>Tour Requests for Unit #{unitId}</h3>
      <ul className={styles.tourList}>
        {tourRequests.map(tour => (
			<li key={tour.id} className={styles.tourItem}>
			  <div className={styles.tourDetails}>
				<strong>{tour.tenantName}</strong>
				<div className={styles.dateTime}>
				  📅 {new Date(tour.requestedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} &nbsp;&nbsp; 
				  🕒 {new Date(tour.requestedAt).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}
				</div>
			  </div>

			  <div className={styles.actions}>
				<span className={`${styles.statusBadge} ${styles[tour.status.toLowerCase().replace(" ", "")]}`}>
				  {tour.status}
				</span>

				{tour.status === "Requested" && (
				  <>
					<button className={styles.approve} onClick={() => handleApprove(tour.id)}>Approve</button>
					<button className={styles.decline} onClick={() => handleDecline(tour.id)}>Decline</button>
				  </>
				)}
			  </div>
			</li>
        ))}
      </ul>
    </div>
  );
};

export default UnitTours;
